import React, {useState, useEffect} from "react";

import {Table} from "../../../common/table/Table";
import {retrieveAllTopicAreas} from "../../../../services/TopicAreaService";

export const TopicAreaTable = ({context, setContext, navigateTo, showToaster, setSpinnerText}) => {

    const [topicAreas, setTopicAreas] = useState([]);

    useEffect(() => {
        setSpinnerText("Fetching Topic Areas");
        const fetchData = async () => {
            const [data, error] = await retrieveAllTopicAreas(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    setTopicAreas(data.topicAreaVOList);
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);


    const handleRowClick = (topicArea) => {
        setContext((prevState) => ({
            ...prevState,
            selectedTopicArea: topicArea,
        }))
        navigateTo("topicAreaCapture");
    }

    const handleAddButtonClick = () => {
        setContext((prevState) => ({
            ...prevState,
            selectedTopicArea: null,
        }));
        navigateTo("topicAreaCapture");
    }

    return (
        <div className="admin-table-container">
            <Table tableData={topicAreas} searchEnabled={true} onRowClick={handleRowClick}
                   buttonText="Add Topic Area" onButtonClick={handleAddButtonClick}
                   hiddenColumns={["externalReference", "isDeleted", "created", "lastModified"]}/>
        </div>
    );
}
